import type { QueryClient } from '@tanstack/react-query';
import { defer } from 'react-router-dom';

import { getUserDetailsQuery } from '../../../queries/getUserDetailsQuery';
import { userAuthStore } from '../../onboarding/stores/userAuthStore';
import { getActionBarQuery } from '../queries/getActionBarQuery';
import { getAnnouncementsQuery } from '../queries/getAnnouncementsQuery';
import { getDoraStatusQuery } from '../queries/getDoraStatusQuery';
import { getImportantActivitiesQuery } from '../queries/getImportantActivitiesQuery';
import { getPlanFeaturesQuery } from '../queries/getPlanFeaturesQuery';

export function discoverPageLoader(queryClient: QueryClient) {
  return async function loader() {
    const isMobileAppV3 = userAuthStore.getState().isMobileAppV3;

    const announcementsQuery = getAnnouncementsQuery({ suspense: true });
    const actionBarQuery = getActionBarQuery({ suspense: true });
    const userDetailsQuery = getUserDetailsQuery({ suspense: false });
    const importantQuery = getImportantActivitiesQuery({ suspense: true });

    const doraStatusQuery = getDoraStatusQuery();
    const planFeaturesQuery = getPlanFeaturesQuery();

    return defer({
      actionBarQueryResponse: queryClient.fetchQuery(actionBarQuery),
      doraStatusQueryResponse: queryClient.fetchQuery(doraStatusQuery),
      userDetailsQueryResponse: queryClient.fetchQuery(userDetailsQuery),
      planFeaturesQueryResponse: queryClient.fetchQuery(planFeaturesQuery),
      ...(!isMobileAppV3 && {
        importantQueryResponse: queryClient.fetchInfiniteQuery(importantQuery),
        announcementsQueryResponse:
          queryClient.fetchInfiniteQuery(announcementsQuery),
      }),
    });
  };
}
